// IMP-439: the Approval step is hidden for launch — the agent always drafts for
// approval (Auto-post removed), so there's nothing to configure. The step is
// dropped from the wizard rather than shown as an explanatory card.
export type WizardStep =
  | "step-connect"
  | "step-tone"
  | "step-behavior"
  | "step-customization"
  | "step-launch"

export const STEP_ORDER: WizardStep[] = [
  "step-connect",
  "step-tone",
  "step-behavior",
  "step-customization",
  "step-launch",
]

export const STEP_TITLE: Record<WizardStep, string> = {
  "step-connect": "Connect Google Business Profile",
  "step-tone": "Tone & voice",
  "step-behavior": "Response behavior",
  "step-customization": "Custom instructions",
  "step-launch": "Test and go live",
}

export function stepFor(raw: string | null | undefined): WizardStep {
  return STEP_ORDER.includes(raw as WizardStep)
    ? (raw as WizardStep)
    : "step-connect"
}
